export type PhoneCountry = {
  iso: string;
  name: string;
  dial: string;
  flag: string;
  flagUrl: string;
};

function flagUrl(iso: string): string {
  return `https://flagcdn.com/24x18/${iso.toLowerCase()}.png`;
}

/** Códigos más usados en LATAM + extras frecuentes (UI tipo Lexgo). */
export const LEXGO_PHONE_COUNTRIES: PhoneCountry[] = [
  { iso: 'CL', name: 'Chile', dial: '+56', flag: '🇨🇱', flagUrl: flagUrl('CL') },
  { iso: 'AR', name: 'Argentina', dial: '+54', flag: '🇦🇷', flagUrl: flagUrl('AR') },
  { iso: 'PE', name: 'Perú', dial: '+51', flag: '🇵🇪', flagUrl: flagUrl('PE') },
  { iso: 'CO', name: 'Colombia', dial: '+57', flag: '🇨🇴', flagUrl: flagUrl('CO') },
  { iso: 'MX', name: 'México', dial: '+52', flag: '🇲🇽', flagUrl: flagUrl('MX') },
  { iso: 'BR', name: 'Brasil', dial: '+55', flag: '🇧🇷', flagUrl: flagUrl('BR') },
  { iso: 'UY', name: 'Uruguay', dial: '+598', flag: '🇺🇾', flagUrl: flagUrl('UY') },
  { iso: 'PY', name: 'Paraguay', dial: '+595', flag: '🇵🇾', flagUrl: flagUrl('PY') },
  { iso: 'BO', name: 'Bolivia', dial: '+591', flag: '🇧🇴', flagUrl: flagUrl('BO') },
  { iso: 'EC', name: 'Ecuador', dial: '+593', flag: '🇪🇨', flagUrl: flagUrl('EC') },
  { iso: 'VE', name: 'Venezuela', dial: '+58', flag: '🇻🇪', flagUrl: flagUrl('VE') },
  { iso: 'CR', name: 'Costa Rica', dial: '+506', flag: '🇨🇷', flagUrl: flagUrl('CR') },
  { iso: 'PA', name: 'Panamá', dial: '+507', flag: '🇵🇦', flagUrl: flagUrl('PA') },
  { iso: 'US', name: 'Estados Unidos', dial: '+1', flag: '🇺🇸', flagUrl: flagUrl('US') },
  { iso: 'ES', name: 'España', dial: '+34', flag: '🇪🇸', flagUrl: flagUrl('ES') }
];

const DEFAULT_ISO = 'CL';

export function getPhoneCountry(iso: string): PhoneCountry {
  return LEXGO_PHONE_COUNTRIES.find((c) => c.iso === iso) || LEXGO_PHONE_COUNTRIES[0];
}

export function composePhone(iso: string, local: string): string | undefined {
  const digits = String(local || '').replace(/\D/g, '');
  if (!digits) return undefined;
  const country = getPhoneCountry(iso || DEFAULT_ISO);
  return `${country.dial}${digits}`;
}

export function parsePhone(phone?: string | null): { iso: string; local: string } {
  const raw = String(phone || '').trim();
  if (!raw) return { iso: DEFAULT_ISO, local: '' };
  const digits = raw.replace(/\D/g, '');
  const sorted = [...LEXGO_PHONE_COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);
  for (const c of sorted) {
    const dialDigits = c.dial.replace(/\D/g, '');
    if (digits.startsWith(dialDigits)) {
      return { iso: c.iso, local: digits.slice(dialDigits.length) };
    }
  }
  return { iso: DEFAULT_ISO, local: digits };
}
